import {RouterModule, Routes} from '@angular/router';
import {DatenschutzComponent} from "./pages/mainpages/datenschutz/datenschutz.component";
import {StartseiteComponent} from "./pages/mainpages/startseite/startseite.component";
import {ImpressumComponent} from "./pages/mainpages/impressum/impressum.component";
import {LoginComponent} from "./pages/mainpages/login/login.component";
import {KontaktComponent} from "./pages/mainpages/kontakt/kontakt.component";
import {NotfoundComponent} from "./pages/mainpages/notfound/notfound.component";
import {JobsucheComponent} from "./pages/bewerber/jobsuche/jobsuche.component";
import {AnueComponent} from "./pages/mainpages/anue/anue.component";
import {AgbComponent} from "./pages/mainpages/agb/agb.component";
import {GvpComponent} from "./pages/mainpages/gvp/gvp.component";
import {MitarbeitersucheComponent} from "./pages/unternehmen/mitarbeitersuche/mitarbeitersuche.component";
import {JobComponent} from "./pages/bewerber/job/job.component";
import {JobFormComponent} from "./pages/admin/forms/jobform/jobform.component";
import {JobsComponent} from "./pages/admin/jobs/jobs.component";
import {FilterkategorienComponent} from "./pages/admin/filterkategorien/filterkategorien.component";
import {UserComponent} from "./pages/admin/user/user.component";
import {NgModule} from "@angular/core";
import {RecruitformComponent} from "./pages/admin/forms/recruitform/recruitform.component";
import {RecruitsComponent} from "./pages/admin/recruits/recruits.component";
import {CustomersComponent} from "./pages/admin/customers/customers.component";
import {CustomerformComponent} from "./pages/admin/forms/customerform/customerform.component";
import {ContactsComponent} from "./pages/admin/contacts/contacts.component";
import {UserformComponent} from "./pages/admin/forms/userform/userform.component";
import {FilterformComponent} from "./pages/admin/forms/filterform/filterform.component";

export const routes: Routes = [
  {
    path: 'startseite',
    component: StartseiteComponent
  },
  {
    path: 'datenschutz',
    component: DatenschutzComponent
  },
  {
    path: 'impressum',
    component: ImpressumComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'kontakt',
    component: KontaktComponent
  },
  {
    path: 'jobsuche',
    component: JobsucheComponent
  },
  {
    path: 'jobsuche/:filter',
    component: JobsucheComponent
  },
  {
    path: 'arbeitnehmerueberlassung',
    component: AnueComponent
  },
  {
    path: 'agb',
    component: AgbComponent
  },
  {
    path: 'gvp',
    component: GvpComponent
  },
  {
    path: 'unternehmen/mitarbeitersuche',
    component: MitarbeitersucheComponent
  },
  {
    path: 'job/:uuid',
    component: JobComponent
  },

  {
    path: 'admin/jobform/:operation',
    component: JobFormComponent
  },
  {
    path: 'admin/jobform/:operation/:uuid',
    component: JobFormComponent
  },
  {
    path: 'admin/customers',
    component: CustomersComponent
  },
  {
    path: 'admin/customerform/:operation',
    component: CustomerformComponent
  },
  {
    path: 'admin/customerform/:operation/:uuid',
    component: CustomerformComponent
  },
  {
    path: 'admin/contacts/:uuid',
    component: ContactsComponent
  },
  {
    path: 'admin/jobs',
    component: JobsComponent
  },
  {
    path: 'admin/filterkategorien',
    component: FilterkategorienComponent
  },
  {
    path: 'admin/filterform',
    component: FilterformComponent
  },
  {
    path: 'admin/filterform/:operation',
    component: FilterformComponent
  },
  {
    path: 'admin/filterform/:operation/:uuid',
    component: FilterformComponent
  },
  {
    path: 'admin/user',
    component: UserComponent
  },
  {
    path: 'admin/userform',
    component: UserformComponent
  },
  {
    path: 'admin/userform/:operation',
    component: UserformComponent
  },
  {
    path: 'admin/userform/:operation/:uuid',
    component: UserformComponent
  },

  {
    path: 'admin/recruits',
    component: RecruitsComponent
  },

  {
    path: 'admin/recruitform/:operation',
    component: RecruitformComponent
  },
  {
    path: 'admin/recruitform/:operation/:uuid',
    component: RecruitformComponent
  },

  {path: "", pathMatch: 'full', redirectTo: '/startseite'},

  {path: '**', component: NotfoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
